import React from "react";
import Sites from "../../constants/Sites";
import Link from "next/link";
import { useRouter } from "next/navigation";

const PrivacyCookiePopup = ({
  setPrivacyCookie,
  siteId,
  data,
  isFeedbackPage,
}) => {
  const router = useRouter();
  return (
    <div className="cookiePolicyPopup">
      <div className="cookiePolicyPopupContent">
        <div>
          <header>We Value Your Privacy</header>
          <p>
            This site uses cookies to improve user experience. By continuing to
            browse, you accept the use of cookies and other technologies.
          </p>
        </div>

        <div className="cookiePolicyPopupButtons">
          <div
            onClick={() => {
              setPrivacyCookie("shown");
              localStorage.setItem("cookiePopup", "shown");
            }}
            className="item"
          >
            <span>I</span>&nbsp;<span>UNDERSTAND</span>
          </div>
          <Link
            href={siteId == Sites.OPENROADMEDIA ? "/privacy" : "/privacy-policy"}
            target="_blank"
            rel="noopener"
          >
            <span className="item">
              <span>LEARN</span>&nbsp;<span>MORE</span>
            </span>
          </Link>
        </div>
      </div>

      <style>
        {`
          .cookiePolicyPopup {
            position: fixed;
            height: fit-content;
            ${router.asPath === "/" &&
            (siteId == Sites.OPENROADMEDIA || siteId == Sites.EARLYBIRDBOOKS)
            ? "bottom: 15px;"
            : isFeedbackPage
              ? "top: 92%;"
              : "top: 80%;"}
            width: 80%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 1000;
            background: #fff;
            border: 1px solid ${data.SiteSettings.site_header.headerColor};
            box-shadow: rgba(0, 0, 0, 0.75) 0px 5px 15px;
            text-align: left;
            color: black;
          }
          .cookiePolicyPopup.hide {
            opacity: 0;
            pointer-events: none;
            transform: scale(0.8);
            transition: all 0.3s ease;
          }
          .cookiePolicyPopupContent header {
            padding: 0px 0px 10px 15px;
            font-size: 20px;
            font-weight: bold;
          }
          .cookiePolicyPopupContent {
            margin: 4px 0 0 0;
            display: flex;
            gap: 1rem;
            align-items: center;
          }
          .cookiePolicyPopupContent p {
            padding: 0px 0px 10px 15px;
            margin: -8px 0;
            font-weight: 500;
            line-height: 22px;
          }
          .cookiePolicyPopupContent .cookiePolicyPopupButtons {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .cookiePolicyPopupButtons div {
            padding: 10px;
            border: none;
            display: block;
            outline: none;
            color: ${data.SiteSettings.site_header.headerTextColor};
            font-size: 0.8rem;
            font-weight: 500;
            background: ${data.SiteSettings.site_header.headerColor};
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
          }
          .cookiePolicyPopupButtons .item {
            margin: 10px;
            font-weight: 600;
          }
          .cookiePolicyPopupButtons a {
            color: ${siteId == Sites.MURDER_MAYHEM
            ? "#000"
            : data.SiteSettings.site_header.headerColor};
            font-size: 13px;
            text-decoration: underline;
            display: block;
          }
          @media (max-width: 1023px) {
            .cookiePolicyPopup {
              position: fixed;
              width: 90%;
              ${router.asPath === "/" &&
            (siteId == Sites.OPENROADMEDIA || siteId == Sites.EARLYBIRDBOOKS)
            ? "bottom: 15px;"
            : "top: 50%;"}
              transform: translate(-50%, -50%);
              left: 50%;
              top: 75%;
            }
            .cookiePolicyPopupContent {
              flex-direction: column;
              gap: 0;
            }
            .cookiePolicyPopupContent header {
              font-size: 0.8rem;
            }
            .cookiePolicyPopupContent p {
              font-size: 0.5rem;
              line-height: 1.5;
            }
            .cookiePolicyPopupButtons {
              width: 100%;
            }
            .cookiePolicyPopupButtons div {
              width: 50%;
            }
            .cookiePolicyPopupButtons a {
              width: 50%;
              text-align: center;
            }
            .cookiePolicyPopupButtons .item {
              font-size: 13px;
            }
          }
          @media (max-width: 575px) {
            .cookiePolicyPopup {
              top: 70%;
            }
          }
        `}
      </style>
    </div>
  );
};

export default PrivacyCookiePopup;
